import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { User } from '@klareospace/pharos-lib-types';
import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createUserApi, userKeys } from '../api';

export function useCancelInvitation(): UseMutationResult<User, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createUserApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<User, Error, string>({
    mutationFn: (id: string) => api.cancelInvitation(id),
    ...createMutationCallbacks({
      errorKey: 'users.actions.cancelInvitation.error',
      invalidateKeys: [userKeys.all],
      queryClient,
      successKey: 'users.actions.cancelInvitation.success',
      t,
    }),
  });
}
